import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import { useAuth } from '../auth/useAuth';

export function UserMenu(): JSX.Element {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    function onDoc(e: MouseEvent): void {
      if (!containerRef.current) return;
      if (!containerRef.current.contains(e.target as Node)) setOpen(false);
    }
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, [open]);

  const initial = (user?.name ?? user?.email ?? '?').slice(0, 1).toUpperCase();

  async function onLogout(): Promise<void> {
    setOpen(false);
    await logout();
    navigate('/login', { replace: true });
  }

  return (
    <div className="user-menu" ref={containerRef}>
      <button
        type="button"
        className="user-menu__trigger"
        onClick={() => setOpen((v) => !v)}
        aria-label="사용자 메뉴"
      >
        <span className="user-menu__avatar">{initial}</span>
        <span className="user-menu__name">{user?.name ?? '게스트'}</span>
        <ChevronDown size={14} aria-hidden />
      </button>
      {open && (
        <div className="user-menu__dropdown" role="menu">
          <div className="user-menu__header">
            <div className="user-menu__header-name">{user?.name ?? ''}</div>
            <div className="user-menu__header-email">{user?.email ?? ''}</div>
          </div>
          <button
            type="button"
            role="menuitem"
            onClick={() => {
              setOpen(false);
              navigate('/settings/profile');
            }}
          >
            프로필
          </button>
          <button
            type="button"
            role="menuitem"
            onClick={() => {
              setOpen(false);
              navigate('/settings/alerts');
            }}
          >
            알림 설정
          </button>
          <div className="user-menu__sep" />
          <button type="button" role="menuitem" onClick={onLogout}>
            로그아웃
          </button>
        </div>
      )}
    </div>
  );
}
